import React from 'react';

const BottomMessageBox = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      {' '}
      <div className="fixed bottom-0 right-0 left-0 w-screen h-max flex items-center justify-end bg-white py-2.5 px-12 shadow-2xl shadow-black z-[11] inset-x-0">
        <div className="flex items-center gap-x-4">{children}</div>
      </div>
    </div>
  );
};

export default BottomMessageBox;
